import { useEffect, useState } from 'react';
import { useBlocker, useLocation } from 'react-router';

interface UseNavigationBlockerOptions {
    shouldBlock: boolean;
    onConfirm: () => void;
}

interface UseNavigationBlockerResult {
    openDialog: boolean;
    handleConfirm: () => void | Promise<void>;
    handleCancel: () => void;
    handleContinue: () => void;
}

export function useNavigationBlocker({
    shouldBlock,
    onConfirm,
}: UseNavigationBlockerOptions): UseNavigationBlockerResult {
    const location = useLocation();
    const blocker = useBlocker(shouldBlock);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        if (blocker.state === 'blocked') {
            const destination = blocker.location.pathname;
            if (destination.includes(location.pathname)) {
                // If the destination is a deeper route of the current path, allow navigation without blocking
                blocker.proceed?.();
                return;
            }
            console.log('Navigation attempt to:', destination);
            setOpen(true);
        }
    }, [blocker, location]);

    return {
        openDialog: open,
        handleConfirm: async () => {
            await onConfirm();
            if (blocker.state === 'blocked') {
                blocker.proceed?.();
            }
            setOpen(false);
        },
        handleCancel: () => {
            blocker.reset?.();
            setOpen(false);
        },
        handleContinue: () => {
            if (blocker.state === 'blocked') {
                blocker.proceed?.();
            }
            setOpen(false);
        },
    };
}
